import React, { useMemo } from "react";
import { useRoomAvailability } from "../../booking/hooks/useRoomAvailability";

function clamp(n, min, max) {
  return Math.max(min, Math.min(max, n));
}

export default function RoomsDonutWidget() {
  const { remaining, loading, error } = useRoomAvailability({
    enabled: true,
  });

  const data = useMemo(() => {
    const totals = {
      r1: 9,
      r2: 10,
      r3: 9,
      r4: 1,
    };

    const totalRooms = totals.r1 + totals.r2 + totals.r3 + totals.r4;

    const remainingRooms =
      Number(remaining?.r1 ?? totals.r1) +
      Number(remaining?.r2 ?? totals.r2) +
      Number(remaining?.r3 ?? totals.r3) +
      Number(remaining?.r4 ?? totals.r4);

    const bookedRooms = clamp(totalRooms - remainingRooms, 0, totalRooms);
    const percentBooked =
      totalRooms > 0 ? Math.round((bookedRooms / totalRooms) * 100) : 0;

    return {
      totalRooms,
      remainingRooms,
      bookedRooms,
      percentBooked,
    };
  }, [remaining]);

  if (loading) {
    return (
      <div className="jp-stat-widget jp-stat-widget--rooms">
        <div className="jp-stat-label">Rooms booked</div>
        <div className="jp-donut jp-donut--loading">
          <div className="jp-donut-inner">…</div>
        </div>
        <div className="jp-stat-sub">Loading rooms</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="jp-stat-widget jp-stat-widget--rooms">
        <div className="jp-stat-label">Rooms booked</div>
        <div className="jp-donut">
          <div className="jp-donut-inner">–</div>
        </div>
        <div className="jp-stat-sub">Unavailable</div>
      </div>
    );
  }

  return (
    <div className="jp-stat-widget jp-stat-widget--rooms">
      <div className="jp-stat-label">Rooms booked</div>

      <div
        className="jp-donut"
        style={{
          background: `conic-gradient(
            #d5a021 0% ${data.percentBooked}%,
            rgba(0,0,0,0.08) ${data.percentBooked}% 100%
          )`,
        }}
      >
        <div className="jp-donut-inner">{data.percentBooked}%</div>
      </div>

      <div className="jp-stat-sub">
        {data.bookedRooms} of {data.totalRooms} rooms
      </div>
    </div>
  );
}
